import React, { useState } from "react";
import "./LinkHome.css";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const LinkHome = ({ color }) => {
  const [works, setWorks] = useState("");
  return (
    <motion.div
      transition={{ duration: 0.2 }}
      animate={{ y: 0, opacity: 1 }}
      initial={{ y: 50, opacity: 0 }}
      className="homeLink"
    >
      <Link to="/">
        <p
          style={{ color: `${color}` }}
          onMouseEnter={() => setWorks("works")}
          onMouseLeave={() => setWorks("")}
        >
          sadik.{works}
        </p>
      </Link>
    </motion.div>
  );
};

export default LinkHome;
